import clsx from 'clsx';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { defaultMaterial, defaultSwatch } from '../../data/materials';
import { isSwatchForbiddden } from '../../data/templateRules';
import useDraft from '../hooks/useDraft';
import { useEditor } from '../hooks/useEditor';
import { Editor } from '../services/Store';
import { Material, Swatch } from '../types';

interface ColorSelectorProps {
    swatchData?: Material['swatches'];
    onChange?: (swatch: Swatch) => void;
}

export default function ColorSelector({
    swatchData = defaultMaterial.swatches,
    onChange,
}: ColorSelectorProps) {
    const {
        editor: { swatch },
    } = useEditor();
    const {
        draft: { template },
    } = useDraft();
    const [currentSwatch, setCurrentSwatch] = useState<Swatch>(swatch);

    function handleSwatchSelect(swatch: Swatch) {
        Editor.setSwatch(swatch);
        setCurrentSwatch(swatch);
        if (onChange) onChange(swatch);
    }

    useEffect(() => {
        if (!currentSwatch) handleSwatchSelect(defaultSwatch);
    }, [currentSwatch]);

    const renderSwatch = (swatch: Swatch) => {
        const forbidden = isSwatchForbiddden(template, swatch);

        return (
            <div
                key={swatch.label}
                className={clsx('color-selector__swatch', {
                    'is-selected':
                        !forbidden &&
                        currentSwatch &&
                        swatch.value === currentSwatch.value,
                    'is-forbidden': forbidden,
                })}
                style={{
                    backgroundColor: !forbidden ? swatch.value : undefined,
                }}
                title={swatch.label}
                onClick={
                    !forbidden ? () => handleSwatchSelect(swatch) : undefined
                }
            />
        );
    };

    return (
        <div className="color-selector">
            <div
                className="color-selector__current"
                title={currentSwatch.label}
            />
            <div className="color-selector__list">
                {swatchData.map((swatch) => renderSwatch(swatch))}
            </div>
        </div>
    );
}
